import { useState, useEffect } from "react";
import { SurchargeModel } from "../models/SurchargeModel";
import { useHistory } from "react-router-dom";
import {
  getSurcharges,
  getDataSurchargeById,
} from "../../../service/surcharge/Surcharger";

export const useGetAll = (loading: number) => {
  const [count, setCount] = useState(1);
  const [dataSurcharge, setDataSurcharge] = useState<SurchargeModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(false);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      setLoadingRequest(true);
      const data = await getSurcharges()
        .then()
        .catch((error) => {
          setLoadingRequest(false);

          history.push("/error/500");
        });
      if (data) {
        setCount(data.count);
        setDataSurcharge(data.rows);
        setLoadingRequest(false);
      }
    };
    fetchPost();
  }, [loading]);
  return { dataSurcharge, count, loadingRequest };
};

export const useGetOne = (id: number) => {
  const initModel = {
    id: 0,
    codigo: "",
    nombre: "",
    valor: 0,
    tipo_id: 0,
    unidad_moneda_id: 0,
  };
  const [initValues, setInitValues] = useState<SurchargeModel>(initModel);

  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getDataSurchargeById(id)
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setInitValues(res);
      }
    };
    if (id) {
      fetchPost();
    } else {
      setInitValues(initModel);
    }
  }, [id]);

  return { initValues };
};
